import Gift from '@/assets/images/christmas/animated-gift.webp'
import AnimatedLogo from '@/assets/images/christmas/animated-logo.svg'
import AnimatedStar from '@/assets/images/christmas/animated-star.svg'
import Ellipsis from '@/assets/images/christmas/ellipsis.svg'

import './styles.css'

export const ChristmasOfferPromotionDialogAnimation = () => {
  return (
    <div className="absolute left-1/2 top-0 z-0 flex h-[278px] w-[423px] -translate-x-1/2 items-center justify-center">
      <Ellipsis className="relative z-10" />
      <img
        src={Gift}
        alt="Gift"
        className="christmas-gift absolute left-[calc(50%+2px)] top-2 z-0 max-w-[243px]"
      />
      <AnimatedStar className="christmas-animation-star absolute z-10" />
      <AnimatedLogo className="christmas-animation-logo absolute z-10" />
    </div>
  )
}
